import React, { useState } from "react"
import { TextTitle } from "../../components/atoms/text/titles"
import { Box, Typography } from "@mui/material"
import { PropertyView } from "../../components/molecules/properties-view"
import { MachineDetails } from "./machineDetails"
import { connectionStateColors, text_colors } from "../../theme"
import { FiberManualRecord } from "@mui/icons-material"
import { ValueViewProps } from "../../components/molecules/properties-view/propertyView"

export const HubHealth = ({ machineDetails }: { machineDetails?: MachineDetails }) => {

  if (!machineDetails) return null

  const errors = machineDetails?.machineErrors.map(item => { return { text: item.text, blocking: item.blocking, display: item.displayError } }) ?? []
  if(machineDetails.connectionState === "Disconnected" ){
        errors.push({text: "No Internet", blocking: false, display: true })
  }
  const errorList = <ErrorMessagesView errors={errors} />


  return (
    <Box style={{ flex: 2 }}>
      <TextTitle title="Hub health" />
      <PropertyView
        Values={[
          { Label: "Connection state:", Path: "connectionState", CustomComponent: ConnectionState },
          { Label: "Liquid level:", Path: "reported.liquidState", CustomComponent: LiquidLevelView },
          { Label: "Screen messages:", ValueComponent: errorList },
        ]}
        Data={machineDetails}
      />
    </Box>
  )
}

type ErrorMessage = {
  text: string;
  blocking: boolean;
  display?: boolean; 
};

const ErrorMessagesView = ({ errors }: { errors: Array<ErrorMessage> }) => {
  console.log("TurboLog ~ ErrorMessagesView ~ errors:", errors)
  const [expanded, setExpanded] = useState(false);

  const visibleErrors = errors.filter(error => error.display === true);

  const hasErrorMessage = visibleErrors.length > 0;
  const hasBlockingMessage = visibleErrors.some(msg => msg.blocking);
  const color = !hasErrorMessage ? text_colors.green : hasBlockingMessage ? text_colors.red : text_colors.yellow;
  
  const isExpandable = visibleErrors.length > 1;

  const text = isExpandable 
    ? (expanded ? "Hide errors" : `Attention Required`)
    : hasErrorMessage 
      ? visibleErrors.map(e => e.text).join(", ") 
      : "No error messages";

  return (
    <div
      onClick={() => isExpandable && setExpanded(!expanded)}
      style={{
        display: "flex",
        flex:1,
        flexDirection: "column",
        gap: 4,
        cursor: isExpandable ? "pointer" : "default" 
      }}>
      
      {/* Header row */}
      {/* Changed alignItems to "flex-start" so the dot doesn't drop to the middle of wrapped text */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: 4 }}>
        {/* Added a small marginTop to optically center the icon with the first line of text */}
        <FiberManualRecord style={{ color, marginTop: 2 }} />
        <Typography
          style={{
            display: "flex",
            fontStyle: hasErrorMessage ? "normal" : "italic",
            color: hasErrorMessage ? "" : "#9e9e9e",
            userSelect: isExpandable ? "none" : "auto"
          }} 
          variant='body1'>
          {text}
        </Typography>
      </div>

      {/* Expanded errors list */}
      {expanded && isExpandable && (
        <div style={{ paddingLeft: 24, display: "flex", flexDirection: "column", gap: 4 }}>
          {visibleErrors.map((error, index) => (
            <Typography 
              key={index} 
              variant='body2' 
            >
              • {error.text}
            </Typography>
          ))}
        </div>
      )}
    </div>
  );
};

const capitalize = s => (s && s[0].toUpperCase() + s.slice(1)) || ""



const ConnectionState = ({ value }: ValueViewProps) => {
  let color = {}

  switch (value) {
    case "Connected":
      color = { color: connectionStateColors.connected }
      break;

    case "Disconnected":
      color = { color: connectionStateColors.disconnected }
      break;

    default:
      color = { color: "white" }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FiberManualRecord style={color} />
      <Typography sx={{ paddingLeft: "4px", paddingTop: "1px" }} color='textPrimary'>
        {capitalize(value)}
      </Typography>
    </Box>
  )
}

const LiquidLevelView = ({ value }: ValueViewProps) => {
  let color = {}

  switch (value) {
    case "good":
      color = { color: text_colors.green }
      break;

    case "low":
      color = { color: text_colors.yellow }
      break;

    case "empty":
      color = { color: text_colors.red }
      break;

    default:
      color = { color: "white" }
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FiberManualRecord style={color} />
      <Typography sx={{ paddingLeft: "4px", paddingTop: "1px" }} color='textPrimary'>
        {capitalize(value)}
      </Typography>
    </Box>
  )
}

